import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const DropDownButton = (props) => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [backButtonView, setBackButtonView] = useState(true);
  const open = Boolean(anchorEl);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const action = (obj) => {
    if (obj.action == "Redirect") {
      handleClose();
      navigation(obj.path);
    }
  };

  const goBack = () => {
    if (
      location.pathname.split("/").includes("Content") &&
      userInfo.rolesInfo.title.toLowerCase() == "trainer"
    ) {
      dispatch(commonSliceActions.setClickPass(true));
    } else {
      navigation(-1);
    }
  };

  useEffect(() => {
    let pathArr = location.pathname.split("/");
    console.log("pathArr", pathArr);
    if (pathArr[0].length == 0 && pathArr.length == 2) {
      if (
        location.pathname.includes("Profile") ||
        location.pathname.includes("LicenseInfo") ||
        location.pathname.includes("CourseConfig") ||
        location.pathname.includes("Vocabulary")
      ) {
        setBackButtonView(true);
      } else {
        setBackButtonView(false);
      }
    } else {
      setBackButtonView(true);
    }
  }, [location]);

  return (
    <Grid
      container
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        flexWrap: "nowrap",
      }}
    >
      {location.pathname.split("/").includes("Content") && (
        <Grid item>
          <Box sx={{ mr: 1 }}>
            <img src={require('../../assets/Vocablab1.png')} width="100%"></img>
          </Box>
        </Grid>
      )}
      <Grid item>
        {backButtonView && (
          <IconButton
            sx={{
              color: "#FFFFFF",
              boxShadow: 1,
              padding: "3px",
              mr: 1,
              backgroundColor: "#5f5600ff",
              '&:hover': { backgroundColor: '#5f5600ff', color: '#FFFFFF' }
            }}
            onClick={goBack}
          >
            <NavigateBeforeIcon
              sx={{
                fontSize: "1.8rem",
                "@media (min-width: 1636px)": {
                  fontSize: "2rem",
                },
              }}
            />
          </IconButton>
        )}
      </Grid>
      <Grid item>
        {props.text && (
          <Typography
            color="#5f5600ff"
            sx={{
              display: "inline",
              fontSize: "1rem",
              fontWeight: "500",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
              },
            }}
          >
            {props.text.replaceAll("$", "")}
          </Typography>
        )}
      </Grid>
      <Grid item>
        {!props.hide && location.pathname.split("/").length <= 2 && (
          <>
            <Button
              id="demo-customized-button"
              aria-controls={open ? "demo-customized-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              endIcon={<KeyboardArrowDownIcon />}
              sx={{
                textTransform: "inherit",
                backgroundColor: "#5f5600ff",
                color: "#FFFFFF",
                fontWeight: "600",
                borderRadius: 10,
               
                "@media (min-width: 1636px)": {
                  fontSize: "1.2rem",
                },
              }}
            >
              {props.title ? props.title : "More"}
            </Button>
            <StyledMenu
              id="demo-customized-menu"
              MenuListProps={{
                "aria-labelledby": "demo-customized-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {props.options &&
                props.options.map((val, index) => {
                  return (
                    <MenuItem
                      onClick={() => {
                        action(val);
                      }}
                      disableRipple
                    >
                      {val.text ? val.text : ""}
                    </MenuItem>
                  );
                })}
            </StyledMenu>
          </>
        )}
      </Grid>
    </Grid>
  );
};
export default DropDownButton;
